import { useState } from 'react';

const CopyProductPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showCopyProductPopup, setShowCopyProductPopup] =
      useState<boolean>(false);

    const copyToggleHandler = () => {
      localStorage.setItem('images', JSON.stringify([]));
      setShowCopyProductPopup(!showCopyProductPopup);
    };

    return (
      <Component
        showCopyProductPopup={showCopyProductPopup}
        copyToggleHandler={copyToggleHandler}
        {...props}
      />
    );
  };

export default CopyProductPopupHOC;
